var map = {
	"./index.mobile.vue": [
		"5018",
		"chunk-2501cf60",
		"report",
		"management.edit"
	],
	"./index.web.vue": [
		"a5c7",
		"chunk-2501cf60",
		"report",
		"management.edit"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1820";
module.exports = webpackAsyncContext;